module.exports = __webpack_public_path__ + "img/background-company.714e148f.jpg";